<!-- <template> -->
	<!-- <div style="display: flex; justify-content: center; width: 100%; height: 202%;background-color: white;position: absolute;z-index: 111;left: 0;top: 0;overflow: hidden;"> -->
		<!-- <img style="width: 80%; height: 40%;margin-top: 120px;" src="http://192.168.2.8:58094/dist//img/资格证书.png" > -->
		<!-- <img style="width: 80%; height: 40%;margin-top: 120px;position: fixed;" src="../assets/logo.png" > -->
	<!-- </div> -->
<!-- </template> -->

<!-- <script>
	
	export default {
		created() {
			document.title = '资格证书'
		}
	}
</script>

<style scoped>
	
</style> -->


<template>
	<div style="display: flex; justify-content: center; width: 100%; height: 100%;">
		<!-- <img style="width: 80%; height: 40%;margin-top: 120px;" src="http://192.168.2.8:58094/dist//img/资格证书.png" > -->
		<img style="width: 60%; height: 60%;" src="../assets/logo.png" >
	</div>
</template>

<script>
	
	export default {
		created() {
			document.title = '资格证书'
		}
	}
</script>

<style scoped>
	
</style>